(function() {

    'use strict';

    angular.module('app').config(dashboardUrlConfig);

    dashboardUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function dashboardUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/dashboard/accounting', {
            templateUrl: '/templates/pages/dashboard/accounting.html',
            controller: 'DashboardAccountingController',
            params: {
                parent: 'dashboard',
                htmlTitle: 'Client',
                pageTitle: 'Client'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();



// WEBPACK FOOTER //
// ./js/urls/dashboard.js